import React, { Fragment, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecureInboxTableRow from './SecureInboxTableRow';
import { FormattedMessage } from 'react-intl';

import { InboxContext } from '../../../../contexts/InboxContext';

const TableHeaderDefault = () => (
    <tr className='header'>
        <th><FormattedMessage id='common.date'/></th>
        <th><FormattedMessage id='common.subject'/></th>
        <th><FontAwesomeIcon icon='paperclip'/><span  className="usa-sr-only"><FormattedMessage id='common.attachment'/></span></th>
    </tr>
);

const SecureInboxTable = props => {

    const {
        notifications,
        setEmailShown
    } = props;
    
    const { isLiteFormat } = useContext(InboxContext);

    const getRows = notifications.map((row, i) => {
        return <SecureInboxTableRow {...{ row, setEmailShown } } key={i} />;
    });
    
    const getTable = () => {
        return (
            <Fragment>
                <div className='desktop:grid-col-12' id='rightpanel'>
                    <div className='gi-panel gi-panel__padding-none'>
                        <table id='inbox' className={`gi-inbox-table table table-condensed table-border-none ${isLiteFormat && 'gi-inbox-table--lite'}`}>
                            <thead>
                                <TableHeaderDefault/> 
                            </thead>
                            <tbody className='msg'>
                                {getRows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            { getTable() }
        </Fragment>
    );
};


export default SecureInboxTable;